<template>
  <v-tooltip top><template v-slot:activator="{ on }"><v-icon v-on="on" 
      :large="large"
      :x-large="xLarge"
      :small="small"
      :light="light"
      :dark="dark"
      :left="left"
      :right="right"
      :color="color">{{icon}}</v-icon></template><span>{{tooltip}}</span></v-tooltip>
</template>
<script>
export default {
  name: "TooltipIcon",
  data() {
    return {};
  },
  props: {
    tooltip: { type: String, default: "OK" },
    icon: { type: String, default: "$ok" },
    color: { type: String },
    small: { type: Boolean },
    large: { type: Boolean },
    xLarge: { type: Boolean },
    dark: { type: Boolean },
    light: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
  },
};
</script>